import { useGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdSummary } from '@fukuri-admins/apis/client/gen/endpoints';

export const useGetStressAssessmentSummary =
  useGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdSummary;
